var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 1.3
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26391",
    d: "M2.619 13.095v-2.88a.555.555 0 01.554-.555h13.653a.556.556 0 01.555.555v2.88",
    stroke: "#a1ff00",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 690",
    stroke: "#a1ff00",
    d: "M10 6.904v6.191"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 5919",
    transform: "translate(7.381 1.667)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.238,
    height: 5.238,
    rx: 0.458,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 3.938,
    height: 3.938,
    rx: 0.192
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 5920",
    transform: "translate(0 13.094)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.238,
    height: 5.238,
    rx: 0.458,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 3.938,
    height: 3.938,
    rx: 0.192
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 5921",
    transform: "translate(7.381 13.094)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.238,
    height: 5.238,
    rx: 0.458,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 3.938,
    height: 3.938,
    rx: 0.192
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 5922",
    transform: "translate(14.761 13.094)",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.238,
    height: 5.238,
    rx: 0.458,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.65,
    y: 0.65,
    width: 3.938,
    height: 3.938,
    rx: 0.192
  })))));
}
export default SvgOrganization;